import { render } from "./ArrowLeft.vue?vue&type=template&id=14163d80&scoped=true"
import script from "./ArrowLeft.vue?vue&type=script&lang=js"
export * from "./ArrowLeft.vue?vue&type=script&lang=js"

import "./ArrowLeft.vue?vue&type=style&index=0&id=14163d80&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14163d80"]])

export default __exports__